import Vue from 'vue'
import VueRouter from 'vue-router'
import BootstrapVue from 'bootstrap-vue'
import httpClient from './httpClient'
import VueMoment from 'vue-moment'

Vue.config.productionTip = false

window.httpClient = httpClient

// Plugins
Vue.use(VueRouter)
Vue.use(VueMoment)

// Install BootstrapVue
Vue.use(BootstrapVue)

// Components
Vue.component('LoadingButton', () => import('./components/LoadingButton.vue'))

// Directives
Vue.directive('focus', {
  inserted (el) {
    el.focus()
  }
})
